import { NotYetAvailableError } from "./errors";
import type { Timestamp } from "./types";

// Typed stubs for endpoints UX-DESIGN.md needs and core-platform does not
// have yet. Each one throws NotYetAvailableError immediately — no request
// is sent and no data is invented — and screens render a clear "not yet
// available" state for it. The proposed response shapes below are the
// contract web/API-GAPS.md asks the backend to implement; the gap id
// matches that table's row. When an endpoint ships, replace its stub with
// a real call in endpoints.ts and delete it from here.
//
// Wired since the first cut (now real calls in endpoints.ts): G-12, G-13,
// G-18 (0052), G-01, G-02, G-05, G-46, G-48 (0055), G-23..G-27 (0056),
// G-31, G-32, G-34, G-35, G-38..G-41, G-44 (0057), G-17, G-19, G-20 (0061),
// G-06..G-09 (0062), G-28, G-43, G-47 (0063), G-30, G-42, G-45 (0065),
// G-33, G-34 (slot lifecycle), G-36, G-37 (0066), G-23/G-38/G-41 receivable
// additions (0067), G-49..G-57 staff console (0068).

function gap(endpoint: string, id: string): never {
  throw new NotYetAvailableError(endpoint, id);
}

// ---- proposed shapes (see API-GAPS.md for field-by-field notes) ----------

export type ComplianceState =
  | "not_started"
  | "pending_verification"
  | "information_requested"
  | "cleared"
  | "failed"
  | "blocked"
  | "rescreening_required";

export interface ComplianceStatus {
  state: ComplianceState;
  requested_items: Array<{ key: string; label: string }>;
  appeal_available: boolean;
  rescreen_due_at: Timestamp | null;
}

// ---- stubs -----------------------------------------------------------------

// G-37 (integration status) shipped in migration 0066 and is now a real
// call: endpoints().publisher.getSiteIntegration (endpoints.ts), typed as
// T.SiteIntegration (types.ts). Its stub is gone from here.

export const gaps = {
  getComplianceStatus: async (): Promise<ComplianceStatus> => gap("GET /v1/compliance", "G-10"),
};
